<script>
		import { createEventDispatcher } from 'svelte';
    import MdcUtils from './MdcUtils';

const dispatch = createEventDispatcher();
export let cash, account;
let errors = []

function copyUrl() {
		navigator.clipboard.writeText(cash.url)
		.then(() => {
			errors = ['URL copied to clipboard']
		})
		.catch(err => {
			errors = ['Error copying URL to clipboard']
		})
}

function share() {
	let file = dataURLtoFile(cash.qr, 'qr.png')
const data = {title: `M$${cash.amt} cash`, text: "Use URL or QR code", url:	cash.url, files: [file]}
		navigator.share(data)
.catch(err => {
		errors = ['Error sharing']
	})
}

function dataURLtoFile(dataurl, filename) {
	var arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]), 
					n = bstr.length, 
					u8arr = new Uint8Array(n);
	while(n--){
					u8arr[n] = bstr.charCodeAt(n);
	}
	return new File([u8arr], filename, {type:mime});
}


function close() {
	dispatch('action',{do:'doSelectAccount', account} )
}

</script>

<div class="modal panel">
<h2>Share Cash</h2>

{#if Object.keys(cash).length>0}

<!-- a QR code containing a URL of the current page-->
<div>
	<p>
<img src={cash.qr} id="cashQr">
</p>
<p>
	{MdcUtils.format(cash.amt)} - {cash.msg}
</p>
<p><!-- a div that looks like a box using inline style with cash.url in it and a button next to it that copies the content of the box to the clipboard -->
	<div style="display:flex;flex-wrap:wrap;">
	<div class="share-cash-url" style="overflow-wrap:break-word;display:inline-block; border:1px solid black; padding:5px; margin:5px; background-color:#eee; width:300px; height:50px; overflow:hidden;">
		{cash.url}
	</div>
	<div style="margin-top:auto;margin-bottom:auto;"><button on:click={copyUrl}>Copy</button></div>
	<div style="margin-top:auto;margin-bottom:auto;"><button on:click={share}>Share</button></div>

</div>

<p><button on:click={close} >Close</button></p>

</div>

{:else}
<p>Sorry, this cash doesn't exist or was picked up.</p>
<p><button on:click={close } >Close</button></p>
{/if}




<!-- if account.msgs, display the messages, one per line, in red font-->
{#if errors}
	<div class="leave-cash-msgs">
		{#each errors as error}
			<div class="leave-cash-msg red">
				{error}
			</div>
		{/each}
	</div>
{/if}


</div>

<style>
	
</style>